<script lang="ts">
	import type { MusicTrack } from '@andresot/protocol/music';
	import { Icon } from '@andresot/ui';
	import { music, musicTime } from '$stores/music.svelte';
	let {
		tracks,
		onadd,
		onremove,
		onmove
	}: {
		tracks: MusicTrack[];
		onadd?: (track: MusicTrack) => void;
		onremove?: (track: MusicTrack) => void;
		onmove?: (index: number, direction: number) => void;
	} = $props();
</script>

<div class="track-list">
	{#each tracks as track, index (track.id)}
		{@const liked = music.library
			? music.library.likes.some((item) => item.id === track.id)
			: track.liked}
		<div class="track" class:current={music.current?.id === track.id}>
			<button
				class="song"
				disabled={!track.available}
				onclick={() => void music.start(tracks, index)}
				aria-label={`Слушать ${track.title} — ${track.artist}`}
			>
				<span class="art"
					>{#if track.artwork}<img
							src={track.artwork}
							alt=""
							loading="lazy"
							referrerpolicy="no-referrer"
						/>{:else}<Icon name="music" size={24} />{/if}</span
				>
				<span class="info"
					><strong>{track.title}</strong><span
						>{track.available ? track.artist : 'Трек недоступен'}</span
					></span
				>
			</button>
			<span class="time">{musicTime(track.duration)}</span>
			<button
				class="like"
				class:liked
				aria-label={liked ? 'Убрать из избранного' : 'Мне нравится'}
				aria-pressed={liked}
				onclick={() => void music.like({ ...track, liked })}><Icon name="heart" size={20} /></button
			>
			<details>
				<summary aria-label={`Действия с треком ${track.title}`}
					><Icon name="more-horizontal" size={20} /></summary
				>
				<div class="actions">
					{#if onadd}<button onclick={() => onadd?.(track)}>В плейлист</button>{/if}
					<button onclick={() => void music.share(track)}>Поделиться</button>
					<button onclick={() => void music.like(track, true)}
						>{track.disliked ? 'Снова рекомендовать' : 'Не нравится'}</button
					>
					{#if onmove}<button disabled={index === 0} onclick={() => onmove?.(index, -1)}
							>Выше</button
						><button disabled={index === tracks.length - 1} onclick={() => onmove?.(index, 1)}
							>Ниже</button
						>{/if}
					{#if onremove}<button onclick={() => onremove?.(track)}>Убрать из плейлиста</button>{/if}
				</div>
			</details>
		</div>
	{/each}
</div>

<style>
	.track-list {
		display: grid;
		gap: var(--size-4);
	}
	.track {
		display: flex;
		align-items: center;
		gap: var(--size-8);
		min-width: 0;
		border-radius: var(--radius-m);
		padding: var(--size-8);
	}
	.track:hover,
	.current {
		background: var(--background-hover);
	}
	button {
		font: inherit;
		color: inherit;
		cursor: pointer;
		border: 0;
		background: none;
	}
	button:disabled {
		opacity: 0.5;
		cursor: default;
	}
	.song {
		display: flex;
		align-items: center;
		gap: var(--size-12);
		flex: 1;
		min-width: 0;
		padding: 0;
		text-align: left;
	}
	.art {
		width: var(--size-48);
		height: var(--size-48);
		flex-shrink: 0;
		border-radius: var(--radius-s);
		overflow: hidden;
		background: var(--background-secondary);
		display: grid;
		place-items: center;
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.info {
		min-width: 0;
		display: grid;
		gap: var(--size-4);
	}
	.info strong,
	.info span {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.info span,
	.time {
		color: var(--text-secondary);
		font-size: var(--font-size-s);
	}
	.like,
	summary {
		display: grid;
		place-items: center;
		width: var(--size-40);
		height: var(--size-40);
		border-radius: var(--radius-round);
	}
	.liked {
		color: var(--accent-primary);
		background: var(--background-selected);
	}
	details {
		position: relative;
	}
	summary {
		list-style: none;
		cursor: pointer;
	}
	summary::-webkit-details-marker {
		display: none;
	}
	.actions {
		position: absolute;
		right: 0;
		top: 100%;
		z-index: 5;
		min-width: 180px;
		padding: var(--size-8);
		background: var(--float-surface);
		box-shadow: var(--shadow-l);
		border: 1px solid var(--border-subtle);
		border-radius: var(--radius-m);
		display: grid;
	}
	.actions button {
		text-align: left;
		padding: var(--size-12);
		border-radius: var(--radius-s);
	}
	.actions button:hover {
		background: var(--background-hover);
	}
	@media (max-width: 600px) {
		.time {
			display: none;
		}
		.track {
			gap: 0;
			padding-inline: 0;
		}
	}
</style>
